SCHEDULE_ENDPOINT